import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { KnowledgeBaseDocument, KnowledgeBaseDocumentCreateDto, Tag } from '@zayan-erp/home-building';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';

export interface TagDto {
  id: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class KnowledgeBaseDocumentService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getDocuments(): Observable<KnowledgeBaseDocument[]> {
    return this.#http.getData(`${this.baseUrl}/KnowledgeBase/documents`, { showLoader: true, showMessage: false });
  }

  getDocumentById(id: string): Observable<KnowledgeBaseDocument> {
    return this.#http.getData(`${this.baseUrl}/KnowledgeBase/documents/${id}`, {
      showLoader: true,
      showMessage: false
    });
  }

  createDocument(document: KnowledgeBaseDocumentCreateDto): Observable<KnowledgeBaseDocument> {
    return this.#http.postData(
      `${this.baseUrl}/KnowledgeBase/documents`,
      { showLoader: true, showMessage: true, message: 'Document created successfully' },
      document
    );
  }

  updateDocument(id: string, document: KnowledgeBaseDocumentCreateDto): Observable<KnowledgeBaseDocument> {
    return this.#http.putData(`${this.baseUrl}/KnowledgeBase/documents/${id}`, document, {
      showLoader: true,
      showMessage: true,
      message: 'Document updated successfully'
    });
  }

  deleteDocument(id: string): Observable<void> {
    return this.#http.deleteData(`${this.baseUrl}/KnowledgeBase/documents/${id}`, {
      showLoader: true,
      showMessage: true,
      message: 'Document deleted successfully'
    });
  }

  bulkDeleteDocuments(ids: string[]): Observable<void> {
    return this.#http.postData(
      `${this.baseUrl}/KnowledgeBase/documents/bulk-delete`,
      { showLoader: true, showMessage: true, message: 'Documents deleted successfully' },
      ids
    );
  }

  getAllTags(): Observable<Tag[]> {
    return this.#http.getData(`${this.baseUrl}/Tag`, { showLoader: true, showMessage: false });
  }
}
